<template>
  <tree-select
    v-model="modelValue"
    placeholder="Selecionar ODS..."
    multiple
    :options="options"
  >
    <template #option-label="{ node, labelClassName }">
      <div
        v-if="node?.raw?.picture"
        class="d-inline-flex w-100 align-items-center flex-wrap"
        :class="labelClassName"
      >
        <img class="picture-label" :src="node?.raw?.picture" />
        <span class="text-wrap text-dark" v-text="node?.raw?.label" />
      </div>
    </template>
    <template #value-label="{ node }">
      <div class="d-inline-flex align-items-center">
        <img class="picture-label" :src="node?.raw?.picture" />
        <span class="text-wrap text-dark" v-text="node?.label" />
      </div>
    </template>
  </tree-select>
</template>

<script>
import { safeArray } from "@/helpers/functions/ArrayHelpers";
import { modelValue } from "@/mixins/modelValue";

import { mapState, mapActions } from "vuex";

export default {
  props: {
    value: {
      type: Array,
      default: null,
    },
  },
  mixins: [modelValue("value", "input")],
  data: () => ({}),
  computed: {
    ...mapState("oportunidades", ["oportunidade", "ods"]),
    options() {
      const toValidUrl = (id) => {
        return `https://odsbrasil.gov.br/content/ods/${id}.png`;
      };

      return safeArray(this.ods).map((item) => ({
        picture: toValidUrl(item.id),
        label: item.name,
        id: item.id,
        value: item.id,
      }));
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionGetOds"]),
  },
  async created() {
    await this.ActionGetOds();
  },
};
</script>

<style scoped lang="scss">
.picture-label {
  width: 26px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 2px;
  object-fit: fill;
  margin-right: 6px;
}

::v-deep .vue-treeselect__list-item {
  & + .vue-treeselect__list-item {
    margin-bottom: 6px;
    margin-top: 6px;
  }
}

::v-deep .vue-treeselect__control {
  height: 43px;
  .vue-treeselect__placeholder {
    line-height: 43px;
  }
}

::v-deep .vue-treeselect__option {
  padding-top: 4px;
  padding-bottom: 4px;
}

::v-deep .vue-treeselect__multi-value-item {
  padding-top: 4px;
  border-radius: 0.25em;
  background: rgba(34, 83, 115, 0.05);

  &:hover {
    background: rgba(34, 83, 115, 0.1);
  }

  .vue-treeselect__multi-value-label {
    padding-right: 6px;
  }

  .vue-treeselect__value-remove {
    color: var(--exitos);
  }

  .picture-label {
    border-radius: 0.15rem;
  }
}

.img_ods {
  transition: all 0.3s;
  cursor: pointer;
  min-width: 5%;

  width: 110px;
  height: 110px;
  margin: 0.1rem !important;
  padding: 0.1rem !important;
}
.img_not_selected {
  filter: grayscale(100%);
  opacity: 0.5;
}
</style>
